// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fc1c5c39","453":"a0b8f908","455":"5017b4a0","977":"89c4875d"}[chunkId] + ".chunk.js";
};